import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { mpDpService } from '../../../services/mp-dp-service/service';

const initialState = {
  cancelSubscriptionPending: false,
  cancelSubscriptionError: false,
  cancelSubscriptionSuccessful: false,
  locationsToCancelSubscription: []
};

export const cancelSubscription = createAsyncThunk(
    'cancelSubscription',
    async (payload) => {
      const {pendingEntities, token, shouldDeleteMarketplaceRecords } = payload;
      const cancel = mpDpService.cancel;
      let promises = [
        cancel.mp_dp_records(pendingEntities, token),
        cancel.consent_records(pendingEntities, token),
        cancel.retry_records(pendingEntities, token)
      ];
      if(shouldDeleteMarketplaceRecords) {
        promises.push(cancel.mp_subscription_records(pendingEntities, token));
      }
      const response = await Promise.all(promises);
      return response;
    }
);


export const cancelSubscriptionSlice = createSlice({
  name: 'cancelSubscriptionSlice',
  initialState,
  reducers: {
    selectLocation: (state, action) => {
      state.locationsToCancelSubscription.push(action.payload);
    },
    removeSelectedLocation: (state, action) => {
      const location = action.payload;
      let locationsToCancelSubscription = state.locationsToCancelSubscription;
      locationsToCancelSubscription =
        state.locationsToCancelSubscription &&
        state.locationsToCancelSubscription.filter(item => 
          item.entityId !== location.entityId
        );
      state.locationsToCancelSubscription = locationsToCancelSubscription;
    },
    selectAllLocations: (state, action) => {
      state.locationsToCancelSubscription = action.payload;
    },
    removeAllLocations : (state, action) => {
      state.locationsToCancelSubscription = [];
    },
    clearPendingLocations: (state) => {
      state.locationsToCancelSubscription = [];
      state.cancelSubscriptionPending = false;
      state.cancelSubscriptionError = false;
      state.cancelSubscriptionSuccessful = false;
    }
  },
  extraReducers: {
    [cancelSubscription.fulfilled]: state => {
        state.cancelSubscriptionPending = false;
        state.cancelSubscriptionError = false;
        state.cancelSubscriptionSuccessful = true;
    },
    [cancelSubscription.pending]: state => {
        state.cancelSubscriptionPending = true;
        state.cancelSubscriptionError = false;
        state.cancelSubscriptionSuccessful = false;
    },
    [cancelSubscription.rejected]: state => {
        state.cancelSubscriptionPending = false;
        state.cancelSubscriptionError = true;
        state.cancelSubscriptionSuccessful = false;
    }
  }
});

export const {
  selectLocation,
  removeSelectedLocation,
  selectAllLocations,
  removeAllLocations,
  clearPendingLocations
} = cancelSubscriptionSlice.actions;

export default cancelSubscriptionSlice.reducer;